import { useState, useMemo, useCallback } from 'react';

export const INIT_SEARCH_STATUS = 'ALL';

export const useSearchQuery = () => {
  const [searchQuery, setSearchQuery] = useState({
    searchSessionName: '',
    searchOwner: '',
    searchStatus: INIT_SEARCH_STATUS,
  });
    
  const paramsSearchQuery = useMemo(() => ({
    searchSessionName: searchQuery.searchSessionName || null,
    searchOwner: searchQuery.searchOwner || null,
    searchStatus: searchQuery.searchStatus,
  }), [searchQuery]);
    
  const handleUpdateSearchSessionName = useCallback((e) => {
    e.persist();
    setSearchQuery((state) => ({...state, searchSessionName: e.target.value}));
  } ,[]);
    
  const handleUpdateSearchOwner = useCallback((e) => {
    e.persist();
    setSearchQuery((state) => ({...state, searchOwner: e.target.value}));
  } ,[]);
    
  const handleSearchStatus = useCallback((e) => {
    e.persist();
    setSearchQuery((state) => ({...state, searchStatus: e.target.value}));
  }, []);

  return {
    searchQuery,
    paramsSearchQuery,
    handleUpdateSearchSessionName,
    handleUpdateSearchOwner,
    handleSearchStatus,
  }
}